import { j as t } from "./jsx-runtime-DmTjM30f.mjs";
import * as c from "react";
import { forwardRef as f, useRef as X, useImperativeHandle as Y, useMemo as x, useState as Z, cloneElement as _, isValidElement as $, memo as P } from "react";
import { c as h } from "./tw-cn-mXgPecoF.mjs";
import { c as S } from "./index.js-Cr0Rsuyz.mjs";
import { u as ee } from "./use-focus-BGKOEgog.mjs";
import { I as B } from "./icon-button-DImUgRzQ.mjs";
import { c as z } from "./index-BpNK5r1N.mjs";
function te(e, r) {
  return /* @__PURE__ */ c.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: r
  }, e), /* @__PURE__ */ c.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25m0 10.803 3.074 3.073q.207.209.522.213a.7.7 0 0 0 .531-.213.72.72 0 0 0 .218-.527.72.72 0 0 0-.218-.526l-3.073-3.074 3.073-3.073a.73.73 0 0 0 .213-.522.7.7 0 0 0-.213-.531.72.72 0 0 0-.526-.218.72.72 0 0 0-.527.218L12 10.946 8.927 7.873a.73.73 0 0 0-.522-.213.7.7 0 0 0-.531.213.72.72 0 0 0-.218.526q0 .31.218.527L10.947 12l-3.073 3.074a.72.72 0 0 0-.213.522.7.7 0 0 0 .213.531q.216.218.526.218a.72.72 0 0 0 .527-.218z",
    clipRule: "evenodd"
  }));
}
var re = S(/* @__PURE__ */ f(te));
function ne(e, r) {
  return /* @__PURE__ */ c.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: r
  }, e), /* @__PURE__ */ c.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M21.339 4.722a.75.75 0 0 0-1.061-1.06L3.661 20.277a.75.75 0 1 0 1.06 1.06l3.46-3.459c1.223.44 2.524.683 3.819.683 4.275 0 8.616-2.663 10.012-6.21a2.24 2.24 0 0 0 0-1.64c-.562-1.43-1.602-2.715-2.923-3.74zm-3.32 3.32-2.02 2.019a4.25 4.25 0 0 1-5.44 5.44l-1.187 1.188a9.7 9.7 0 0 0 2.628.373c3.768 0 7.483-2.38 8.616-5.26a.74.74 0 0 0 0-.542c-.475-1.206-1.403-2.325-2.598-3.218",
    clipRule: "evenodd"
  }), /* @__PURE__ */ c.createElement("path", {
    fill: "currentColor",
    d: "M15.965 5.237A11.4 11.4 0 0 0 12 4.5c-4.276 0-8.616 2.663-10.012 6.211a2.24 2.24 0 0 0 0 1.64c.578 1.47 1.661 2.788 3.036 3.827l1.073-1.073c-1.25-.906-2.224-2.058-2.714-3.303a.74.74 0 0 1 0-.542C4.517 8.381 8.232 6 12 6c.944 0 1.885.15 2.784.42z"
  }), /* @__PURE__ */ c.createElement("path", {
    fill: "currentColor",
    d: "M13.63 7.573a4.25 4.25 0 0 0-5.556 5.556l1.208-1.208a2.75 2.75 0 0 1 3.139-3.139z"
  }));
}
var le = S(/* @__PURE__ */ f(ne));
function ae(e, r) {
  return /* @__PURE__ */ c.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: r
  }, e), /* @__PURE__ */ c.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 7.25a4.25 4.25 0 1 0 0 8.5 4.25 4.25 0 0 0 0-8.5M9.25 11.5a2.75 2.75 0 1 1 5.5 0 2.75 2.75 0 0 1-5.5 0",
    clipRule: "evenodd"
  }), /* @__PURE__ */ c.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 4.5c-4.276 0-8.616 2.663-10.012 6.211a2.24 2.24 0 0 0 0 1.64C3.384 15.9 7.724 18.562 12 18.562c4.275 0 8.616-2.663 10.012-6.21a2.24 2.24 0 0 0 0-1.64C20.616 7.162 16.275 4.5 12 4.5m-8.617 6.76C4.517 8.382 8.232 6 12 6s7.483 2.381 8.616 5.26a.74.74 0 0 1 0 .542c-1.133 2.88-4.848 5.26-8.616 5.26s-7.483-2.38-8.617-5.26a.74.74 0 0 1 0-.541",
    clipRule: "evenodd"
  }));
}
var ie = S(/* @__PURE__ */ f(ae));
const se = ["default", "large"], ue = z(["border border-solid relative flex items-center rounded-8 py-4 px-16"], {
  variants: {
    mobileSize: {
      default: "min-h-44",
      large: "min-h-56"
    },
    pcSize: {
      default: "pc:min-h-44",
      large: "pc:min-h-56"
    },
    isFocused: {
      true: "border-2 px-15",
      false: ""
    },
    disabled: {
      true: "bg-fill-neutral-weak",
      false: "bg-static-white"
    },
    isShowRightIconButton: {
      true: "",
      false: ""
    }
  },
  compoundVariants: [
    ...se.flatMap((e) => [
      {
        isFocused: !1,
        mobileSize: e,
        isShowRightIconButton: !0,
        className: e === "default" ? "pr-8" : "pr-10"
      },
      {
        isFocused: !0,
        mobileSize: e,
        isShowRightIconButton: !0,
        className: e === "default" ? "pr-7" : "pr-9"
      },
      {
        isFocused: !1,
        pcSize: e,
        isShowRightIconButton: !0,
        className: e === "default" ? "pc:pr-8" : "pc:pr-10"
      },
      {
        isFocused: !0,
        pcSize: e,
        isShowRightIconButton: !0,
        className: e === "default" ? "pc:pr-7" : "pc:pr-9"
      }
    ])
  ],
  defaultVariants: {
    mobileSize: "default",
    pcSize: "default",
    isShowRightIconButton: !1,
    isFocused: !1
  }
}), oe = z(
  [
    "size-full placeholder:text-text-neutral-medium text-text-neutral-main disabled:text-interaction-neutral-disable-main disabled:placeholder:text-interaction-neutral-disable-main disabled:bg-fill-neutral-weak",
    // number 타입 input의 화살표 숨김
    "[appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
  ],
  {
    variants: {
      mobileSize: {
        default: "typography-subtitle-16-regular",
        large: "typography-subtitle-18-regular"
      },
      pcSize: {
        default: "pc:typography-subtitle-16-regular",
        large: "pc:typography-subtitle-18-regular"
      }
    },
    defaultVariants: {
      mobileSize: "default",
      pcSize: "default"
    }
  }
), ce = (e) => $(e) && e.type === "button", pe = ({ children: e }) => ce(e) ? _(e, { tabIndex: -1 }) : e, V = f(
  ({
    id: e,
    type: r = "text",
    value: n,
    disabled: a,
    onChange: i,
    onBlur: u,
    hasError: o = !1,
    placeholder: m,
    mobileSize: p = "default",
    pcSize: d = "default",
    rightTextButton: I,
    onClearCallback: v,
    onPasswordToggleCallback: b,
    showPasswordVisibleButton: N,
    showClearButton: R = !1,
    inputWrapperClassName: T,
    inputClassName: W,
    ...q
  }, O) => {
    var M;
    const s = X(null), { isFocused: y } = ee(s);
    Y(O, () => s.current);
    const F = x(() => p === "default" ? "small" : "medium", [p]), E = x(() => d === "default" ? "small" : "medium", [d]), [g, C] = Z(!1), A = ue({
      disabled: a,
      mobileSize: p,
      pcSize: d,
      isFocused: y,
      isShowRightIconButton: !!(R || N)
    }), H = oe({ mobileSize: p, pcSize: d }), k = x(() => a ? "border-line-neutral-weak3" : o ? "border-line-danger-main caret-text-danger-main" : y ? "border-line-neutral-main" : "border-line-neutral-weak3", [a, o, y]), G = (l) => {
      u == null || u(l);
    }, J = (l) => {
      l.preventDefault();
      const w = s.current;
      w && (w.value = "", D(), i && i({
        target: w,
        currentTarget: w
      })), v == null || v();
    }, D = () => {
      if (s.current) {
        const l = s.current.value.length || (n == null ? void 0 : n.toString().length) || 0;
        window.setTimeout(() => {
          s.current && s.current.setSelectionRange(l, l);
        }, 0), s.current.focus();
      }
    }, K = () => {
      C(!g), D(), b == null || b();
    }, Q = (l) => {
      i == null || i(l);
    }, U = x(() => r === "password" ? g ? "text" : "password" : r, [r, g]);
    return /* @__PURE__ */ t.jsxs("div", { className: h(A, k, T), children: [
      /* @__PURE__ */ t.jsx(
        "input",
        {
          className: h(H, W),
          disabled: a,
          id: e,
          onBlur: G,
          onChange: Q,
          placeholder: m,
          ref: s,
          type: U,
          value: n,
          ...q
        }
      ),
      a ? null : /* @__PURE__ */ t.jsx(t.Fragment, { children: I ? /* @__PURE__ */ t.jsx(pe, { children: /* @__PURE__ */ t.jsx("div", { className: "pl-8", children: I }) }) : (n || ((M = s.current) == null ? void 0 : M.value)) && /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
        R ? /* @__PURE__ */ t.jsx(
          B,
          {
            icon: /* @__PURE__ */ t.jsx(re, {}),
            onClick: J,
            onMouseDown: (l) => {
              l.preventDefault();
            },
            size: { mobile: F, pc: E },
            tabIndex: -1,
            theme: "ghost"
          }
        ) : null,
        r === "password" && N ? /* @__PURE__ */ t.jsx(
          B,
          {
            icon: g ? /* @__PURE__ */ t.jsx(ie, {}) : /* @__PURE__ */ t.jsx(le, {}),
            onClick: K,
            onMouseDown: (l) => {
              l.preventDefault();
            },
            size: { mobile: F, pc: E },
            tabIndex: -1,
            theme: "ghost"
          }
        ) : null
      ] }) })
    ] });
  }
);
V.displayName = "NDS.Input";
const L = f(({ children: e, ...r }, n) => /* @__PURE__ */ t.jsx("label", { ref: n, ...r, className: "flex-start flex", children: typeof e == "string" ? /* @__PURE__ */ t.jsx("span", { className: "text-text-neutral-main typography-body-13-regular", children: e }) : e }));
L.displayName = "NDS.Label";
const j = ({ leftContent: e, rightContent: r, hasError: n, disabled: a }) => {
  const i = x(() => a ? "text-interaction-neutral-disable-main" : n ? "text-text-danger-main" : "text-text-neutral-main", [a, n]), u = (o, m) => typeof o == "string" ? /* @__PURE__ */ t.jsx("span", { className: m, children: o }) : o;
  return /* @__PURE__ */ t.jsxs("div", { className: "flex w-full justify-between px-16 text-left", children: [
    e ? /* @__PURE__ */ t.jsx("div", { className: "mr-8", children: u(e, h("line-clamp-2 typography-body-12-regular-multiline", i)) }) : null,
    r ? /* @__PURE__ */ t.jsx("div", { className: "ml-auto", children: u(r, h("whitespace-nowrap text-text-neutral-main typography-body-12-regular")) }) : null
  ] });
};
j.displayName = "NDS.Support";
P(j);
const de = f(
  ({
    className: e,
    id: r,
    label: n,
    supportLeftContent: a,
    supportRightContent: i,
    hasError: u = !1,
    disabled: o = !1,
    inputRef: m,
    ...p
  }, d) => /* @__PURE__ */ t.jsxs("div", { className: h("flex w-full flex-col gap-8", e), ref: d, children: [
    n ? /* @__PURE__ */ t.jsx(L, { htmlFor: r, children: n }) : null,
    /* @__PURE__ */ t.jsx(V, { disabled: o, hasError: u, id: r, ref: m, ...p }),
    a || i ? /* @__PURE__ */ t.jsx(
      j,
      {
        disabled: o,
        hasError: u,
        leftContent: a,
        rightContent: i
      }
    ) : null
  ] })
);
de.displayName = "NDS.TextField";
export {
  de as T
};
